import scoutScene from '../../assets/class-scenes/scout.webp';
import clericScene from '../../assets/class-scenes/cleric.webp';
import bardScene from '../../assets/class-scenes/bard.webp';
import warriorScene from '../../assets/class-scenes/warrior.webp';
import druidScene from '../../assets/class-scenes/druid.webp';
import mageScene from '../../assets/class-scenes/mage.webp';
import crafterScene from '../../assets/class-scenes/crafter.webp';
import alchemistScene from '../../assets/class-scenes/alchemist.webp';
import logisticsScene from '../../assets/class-scenes/logistics.webp';
import guardianScene from '../../assets/class-scenes/guardian.webp';

import scoutSceneLight from '../../assets/class-scenes/scout-light.webp';
import clericSceneLight from '../../assets/class-scenes/cleric-light.webp';
import bardSceneLight from '../../assets/class-scenes/bard-light.webp';
import warriorSceneLight from '../../assets/class-scenes/warrior-light.webp';
import druidSceneLight from '../../assets/class-scenes/druid-light.webp';
import mageSceneLight from '../../assets/class-scenes/mage-light.webp';
import crafterSceneLight from '../../assets/class-scenes/crafter-light.webp';
import alchemistSceneLight from '../../assets/class-scenes/alchemist-light.webp';
import logisticsSceneLight from '../../assets/class-scenes/logistics-light.webp';
import guardianSceneLight from '../../assets/class-scenes/guardian-light.webp';

export const CLASS_SCENES_DARK = {
  SCOUT: scoutScene,
  MEDIC: clericScene,
  SOCIAL: bardScene,
  TANK: warriorScene,
  ENVIRONMENT: druidScene,
  TECH: mageScene,
  CRAFTER: crafterScene,
  NUTRITION: alchemistScene,
  LOGISTICS: logisticsScene,
  GUARDIAN: guardianScene,
};

export const CLASS_SCENES_LIGHT = {
  SCOUT: scoutSceneLight,
  MEDIC: clericSceneLight,
  SOCIAL: bardSceneLight,
  TANK: warriorSceneLight,
  ENVIRONMENT: druidSceneLight,
  TECH: mageSceneLight,
  CRAFTER: crafterSceneLight,
  NUTRITION: alchemistSceneLight,
  LOGISTICS: logisticsSceneLight,
  GUARDIAN: guardianSceneLight,
};
